/**
 * @description a method to conditionally apply "kwargs" into an array. If the first param is true, it will invoke the second param.
 * @see http://2ality.com/2017/04/conditional-literal-entries.html#variations-of-the-original-approach
 * @example
 *  [1, 2, ...insertIf(true, () => [3, 4, 5])] ==> [1, 2, 3, 4, 5]
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function insertIf<T = any>(condition: boolean, callback: () => T[]) {
  return condition ? callback() : [];
}
